<template>
  <div class="ai-block">
    <div class="ai-block-cons">
      <div class="ai-cons">
        <img src="../../../assets/images/home/img12.png" class="tip-img1" alt="">
        <div class="ai-cons-html" v-html="explainContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {dictionaryList} from '../../../api/api'

export default {
  props: ['value'],
  data() {
    return {
      explainContent: '',
    }
  },
  created() {
    this.handleAssistantIsStop()
  },
  methods: {
    // 获取智能助手是否停止
    async handleAssistantIsStop() {
      try {
        // 获取智能助手目前是否在停用
        const response = await dictionaryList({ typeCode: 'INTELLIGENT_ASSISTANT', dataStatus: 1 })

        // 类型校验，确保 data 是数组
        const dataList = Array.isArray(response.data) ? response.data : []

        // 一次遍历完成判断和提取
        const shutdownItem = dataList.find(item => item.code === 'SHUTDOWN')

        if (shutdownItem) {
          this.$emit('input', true)
          this.explainContent = shutdownItem.explainContent || ''
        } else {
          this.$emit('input', false)
          this.explainContent = ''
        }
      } catch (e) {
        console.error(e)
      }
    },
  }
}
</script>

<style scoped lang="less">
.ai-block {
  padding: 0 14px 20px;
  box-sizing: border-box;
  margin-top: 10px;

  .cons-list {
    padding: 0;
  }

  .ai-block-cons {
    background: #F9F8F7;
    border-radius: 12px;
    padding: 12px 10px 1px 14px;
    box-sizing: border-box;

    .tip-img1 {
      height: 20px;
      display: block;
      margin-bottom: 10px;
    }

    .tip-img2 {
      width: 104px;
      display: block;
      margin-bottom: 8px;
    }

    .ai-cons-html {
      margin-bottom: 20px;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      overflow: hidden;
      font-size: 14px;
      color: #333;
      line-height: 24px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      transition: max-height 0.5s ease;
      /* 添加过渡效果 */

      &.close {
        // -webkit-line-clamp: unset;
        /* 展开后不限制行数 */
        max-height: null;
      }

      &.open {
        // -webkit-line-clamp: 7;
        /* 展开后不限制行数 */
        max-height: 168px;
      }
    }

    .ai-tips {
      font-family: Source Han Sans CN, Source Han Sans CN;
      color: rgba(255, 38, 38, 0.84);
      font-size: 12px;
      line-height: 20px;
    }

    .btm-txt-block {
      display: flex;
      justify-content: space-between;
      position: relative;
      top: -15px;

      .btm-txt2 {
        color: #EB1700;
        font-size: 13px;
        font-weight: 500;
        line-height: 20px;
        display: flex;
        min-width: 40px;

        .icon-btm {
          display: block;
          width: 12px;
          height: 7px;
          margin-left: 2px;
          position: relative;
          top: 6px;

          &.rotate {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/assistantIsStop.vue